import React from "react";

const PrivacyPolicy = () => {
  return (
    <section className="bg-paper py-16 lg:py-24">
      <div className="max-w-content mx-auto px-6 lg:px-10">
        <div className="max-w-prose">
          <h1 className="text-3xl font-bold text-brand sm:text-4xl">Privacy policy</h1>
          <p className="mt-2 text-sm text-muted">Last updated: September 2026</p>

          <div className="mt-8 space-y-6 text-muted">
            <p>
              This policy explains what Nirkana Groups ("we", "us") collects
              when you use this website — to request a quote, contact us,
              register as a vendor, or simply browse — and how that
              information is used.
            </p>

            <div>
              <h2 className="text-lg font-medium text-charcoal">Information you provide</h2>
              <p className="mt-2">
                When you submit the quote, contact, or vendor forms, we
                collect the details you provide: name, phone number, email
                (where asked), event date, guest count, general location,
                and any message you include. We do not ask for government
                ID numbers or other sensitive identifiers through this site.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-medium text-charcoal">Information collected automatically</h2>
              <p className="mt-2">
                When you visit this site, we log basic visit information —
                the page viewed, the referring site, the time, and an
                approximate location (city/region) inferred from your IP
                address via a third-party lookup service. This is used only
                to understand where enquiries and traffic come from, not to
                identify you personally. It does not run if your browser
                blocks it.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-medium text-charcoal">How we use it</h2>
              <p className="mt-2">
                We use this information to respond to enquiries, prepare
                quotes, evaluate vendor applications, and understand how
                people find this site. We do not sell your information to
                third parties.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-medium text-charcoal">Sharing with partners</h2>
              <p className="mt-2">
                If you book an event, relevant details (such as event date,
                guest count, and location) are shared with the specific
                service partners assigned to your event — for example, your
                decor or catering vendor — strictly to fulfil that booking.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-medium text-charcoal">Cookies</h2>
              <p className="mt-2">
                This site does not use advertising or tracking cookies. The
                one exception is a small marker stored in your browser
                session (not a persistent cookie) to avoid logging the same
                visit twice.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-medium text-charcoal">Your rights</h2>
              <p className="mt-2">
                You can request a copy of the information we hold about you,
                or ask us to delete it, by emailing{" "}
                <a href="mailto:info@nirkana.com" className="text-action hover:underline">
                  info@nirkana.com
                </a>.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-medium text-charcoal">Children's privacy</h2>
              <p className="mt-2">
                This site is intended for use by adults planning events. We
                do not knowingly collect personal information from children
                using this site directly.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-medium text-charcoal">Contact</h2>
              <p className="mt-2">
                Questions about this policy: {" "}
                <a href="mailto:info@nirkana.com" className="text-action hover:underline">
                  info@nirkana.com
                </a>{" "}
                or{" "}
                <a href="tel:+919080924318" className="text-action hover:underline">
                  +91 90809 24318
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
